import React from 'react';
import { connect } from 'react-redux';
import { Icon, Input, List, message, Tag, Row, Col, Button } from 'antd';
import EnterpriseSelector from './enterprise-selector'
import debounce from 'debounce';

import AddGhostUserDrawer from '../../user/add-ghost-drawer';
// import quotation from '..';
import UserAddresses from './user-addresses';

import {
	setQuotationActiveBilling,
	setQuotationActiveShipping,
  setQuotationEnterprise,
	setQuotationUser,
	setQuotationUserNewAddress
} from '../actions';

import { 
  _getEnterpriseData,
	_getSearchUserEmails, 
	_postAssignUserToQuotation,
	_postSetQuotationBilling,
	_postSetQuotationShipping
} from '../../../services';

class UserSelector extends React.Component{

	render(){
		
		const { loading } = this.state;

		return (
			<div>
				
				{
					this.state.addGhostUser && (
						<AddGhostUserDrawer 
							defaultEmail={ this.state.searchParam }
							visible={ this.state.addGhostUser }
							onClose={ this.onCloseAddGhostUser }
							/>
					)
				}

				<div>
					{/* input */}
		
					<div
						style={{
							width:400,
							position: 'relative',
							margin: "36px auto" 
						}}
						ref={ node => this.autoCompleteNode = node }>

						<Input 
							disabled={ this.state.changeUserDisabled }
							size="large"
							style={{ width: 400 }}
							value={ this.state.searchParam }
							onChange={ this.handleOnChange }
							onClick={ () => this.doSearch( this.state.searchParam ) }
							placeholder="User Email"
							/>
	
						{loading && (
							<List
								style={{ 
									width: 400,
									top: 36,
									position: "absolute"
								}}
								className="search-dropdown">
	
								<List.Item>
									Loading...
								</List.Item>
							</List>
						)}
						
						{/* autocomplete dropdown */}
						{
							!loading && this.state.users.length > 0 && (
								<List
									style={{ 
										width: 400,
										top: 36,
										position: "absolute"
									}}
									className="search-dropdown"
									dataSource={this.state.users}
									renderItem={ user => (
	
										<List.Item>
	
											{ this.renderItem(user) }
	
										</List.Item>
	
									)}
								/>
							)
						}

					</div>

					{/* render user details */}
					{this.renderUserDetails()}


				</div>
				
				{ this.renderAddresses("shipping") }

				{ this.renderAddresses("billing") }


        {this.props.quotation.cart.user && 
        <div style={{ marginTop: 12}}>
          {this.props.quotation.enterprise.companyName &&
          <h4>
            Enterprise: {this.props.quotation.enterprise.companyName}
          </h4>
          }
          <Row 
          gutter={16}
          type="flex">
            <Col>
              <EnterpriseSelector
                text={this.props.quotation.enterprise._id? "Change Enterprise": "Attach Enterprise Prices"}
                onSelect={this.handleSelectEnterprise}
              />
            </Col>
            {this.props.quotation.enterprise._id && <Col>
              <Button 
              onClick={this.removeEnterprise}
              type="danger" ghost>
                Remove Enterprise
              </Button>
            </Col>}
          </Row>
        </div>}

			</div>
		)

	}

	renderAddresses = ( addressType ) => {

		let addresses = [];

		let selectedAddressId, onSelectAddress, title;
		
		switch( addressType ){
			case "billing":
				title = "Choose Billing Address";
				onSelectAddress = this.onSelectBilling;
				selectedAddressId = this.props.quotation.cart.activeBilling && this.props.quotation.cart.activeBilling._id || "";
				break;

			case "shipping":
				title = "Choose Shipping Address";
				onSelectAddress = this.onSelectShipping;
				selectedAddressId = this.props.quotation.cart.activeShipping && this.props.quotation.cart.activeShipping._id || "";
				break;
		}

		if( this.props.quotation.cart.user && this.props.quotation.cart.user._id ){
			
			// if punchout cart (shell)
			if( this.props.quotation.cart.punchoutCart ){

				switch( addressType ){
					case "billing":
							addresses = this.props.quotation.cart.user.addresses.filter( _address => _address.billingOnly );
						break;

					case "shipping":
							addresses = this.props.quotation.cart.user.addresses.filter( _address => !_address.billingOnly );
						break
				}

			} else {
				addresses = this.props.quotation.cart.user.addresses;
			}
		}
		
		return (
			<UserAddresses 
				cart={this.props.quotation.cart}
				user={this.props.quotation.cart.user}
				selectedAddressId={ selectedAddressId }
				onSelectAddress={ onSelectAddress }
				addresses={ addresses }
				title={ title }
				setQuotationUser = {this.props.setQuotationUser}
			/>

		)
	}

	renderItem = ( user ) => {
		if( user._id === "INVITE_NEW_USER" ){
			return (
				<div style={{ width: "100%" }} onClick={ this.onOpenAddGhostUser }>
					<a>
						<Icon type="plus" theme="outlined" /> Invite new user
					</a>
				</div>
			);
		}

		return (
			<div style={{ width: "100%" }} onClick={ () => this.handleOnClickUser( user ) }>
				{user.local.email}<br/>
				<Tag>{user.details.companyName?`${user.details.companyName}`:"No Company"}</Tag>
				
			</div>
		);

	}

	renderUserDetails = (  ) => {
		const user = this.props.quotation.cart && this.props.quotation.cart.user;

		if( !user ){
			return null;
			// return (
			// 	<h3 style={{ marginTop: 32, textAlign:"center", width: "100%"}}>
			// 		Please assign a user
			// 	</h3>
			// )
		}

		return (
			<h2>
				Email: { user.local.email }
			</h2>
		)
	}

	constructor( props ){
		super( props );

		let changeUserDisabled = false,
			loadingUser = false;

		if( this.props.quotation.cart.punchoutCart ){
			changeUserDisabled = true;
			loadingUser = true;

			const 	quotationId = this.props.quotation.cart._id,
					userId = this.props.quotation.cart.user._id;

			_postAssignUserToQuotation({
				quotationId,
				userId 
			})
				.then( res => {

					this.props.setQuotationUser( res.data.user );

          if (res.data.user.enterpriseId) {
            _getEnterpriseData(res.data.user.enterpriseId)
            .then( enterpriseRes => {
              this.props.setQuotationEnterprise(enterpriseRes.data.enterprise)
            })
          }

					this.setState({
						loadingUser: false
					});
				})
				.catch( e => {
					message.error("There was an unexpected error. Please try again.");
				})
	
		}

		this.state = {
			addGhostUser: false,
			changeUserDisabled,
			loading: false,
			loadingUser,
			searchParam: '',
			users: []
		}

		this.debouncedSearch = debounce(this.debouncedSearch, 300);


	}
	
	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutsideAutoComplete);
	}
	
	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutsideAutoComplete);
	}

	debouncedSearch = ( searchParam ) => {
		// searchParam
		this.doSearch( searchParam );

	}

	doSearch = ( searchParam ) => {

		if( !searchParam ){
			return this.setState({ 
				users: [],
				loading: false
			});
		}

		_getSearchUserEmails( searchParam, 6 )
			.then( res => { this.setState({
					users: [
						{
							_id: "INVITE_NEW_USER"
						},
						...res.data.users
					],
					loading: false
				}) 
			})

	}

  handleSelectEnterprise = (enterprise) => {
    this.props.setQuotationEnterprise(enterprise)
  }
	

	handleOnChange = ( e ) => {

		this.debouncedSearch( e.target.value );

		if( !e.target.value ){

			return this.setState({
				searchParam: "",
				loading: false,
				user: []
			})

		}

		this.setState({
			users:[],
			loading: true,
			searchParam: e.target.value
		});

		

	}
	
	handleClickOutsideAutoComplete = ( event ) => {
		
		if ( this.autoCompleteNode && !this.autoCompleteNode.contains(event.target) ) {
			this.setState({
				users: []
			})
		}
	}
	
	handleOnClickUser = ( user ) => {
		
		this.setState({
			users: [],
			searchParam: user.local.email
		});

		const quotationId = this.props.quotation.cart._id;

		_postAssignUserToQuotation({
			quotationId,
			userId: user._id 
		})
			.then( res => {
				message.success(`Assigned ${res.data.user.local.email} to quote`);
				this.props.setQuotationUser( res.data.user );

        if (res.data.user.enterpriseId) {
          _getEnterpriseData(res.data.user.enterpriseId)
          .then( enterpriseRes => {
            this.props.setQuotationEnterprise(enterpriseRes.data.enterprise)
          })
        } else {
          this.props.setQuotationEnterprise({})
        }
		
			})
			.catch( e => {
				message.error("There was an unexpected error. Please try again.");
			})
		
		// send to server
	}

	onCloseAddGhostUser = ( user ) => {

		const quotationId = this.props.quotation.cart._id;

		_postAssignUserToQuotation({
			quotationId,
			userId: user._id 
		})
			.then( res => {
				message.success(`Assigned ${res.data.user.local.email} to quote`);
				this.props.setQuotationUser( res.data.user );
				this.setState({ 
					addGhostUser: false,
					searchParam: ""
				});
			})
			.catch( e => {
				message.error("There was an unexpected error. Please try again.");
			})

	}

	onOpenAddGhostUser = () => {
		this.setState({
			addGhostUser: true,
			users: []
		});
	}

	onSelectBilling = ( address ) => {

		const { cart } = this.props.quotation;

		message.loading('Changing Billing Address');

		_postSetQuotationBilling({
			quotationId: cart._id,
			userId: cart.user._id,
			locationId: address._id
		})
			.then( res => {
				setTimeout(() => {
					message.destroy();
					this.props.setQuotationActiveBilling( res.data.address );
				}, 400);
			})
		

	}

	onSelectShipping = ( address ) => {

		const { cart } = this.props.quotation;

		message.loading('Changing Shipping Address');

		_postSetQuotationShipping({
			quotationId: cart._id,
			userId: cart.user._id,
			locationId: address._id
		})
			.then( res => {
				setTimeout(() => {
					message.destroy();
					this.props.setQuotationActiveShipping( res.data.address );
				}, 400);
			})
	
	
	}

  removeEnterprise = () => {
    this.props.setQuotationEnterprise({})
  }

}

export default connect(
	state => ({
		quotation: state.quotation
	}),

	dispatchEvent => ({
		setQuotationActiveBilling: ( address ) => dispatchEvent( setQuotationActiveBilling(address) ),
		setQuotationActiveShipping: ( address ) => dispatchEvent( setQuotationActiveShipping(address) ),
    setQuotationEnterprise: (enterprise) => dispatchEvent( setQuotationEnterprise(enterprise)),
		setQuotationUser: ( user ) => dispatchEvent( setQuotationUser( user ) ),
		setQuotationUserNewAddress: ( address ) => dispatchEvent( setQuotationUserNewAddress( address) )
	})
)(UserSelector);


// WEBPACK FOOTER //
// ./src/components/quotation/add-quotation-modal/user-selector.js